/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tracking_Today_DistanceInputs */

const vi_tracking_today_distance = /** @type {(inputs: Tracking_Today_DistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quãng đường hôm nay`)
};

/**

* @param {Tracking_Today_DistanceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tracking_today_distance = /** @type {((inputs?: Tracking_Today_DistanceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tracking_Today_DistanceInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tracking_today_distance(inputs)
});